import { useState } from "react";
import { fileService } from "../../services/image.service";
import { CustomModal, CustomModalProps } from "./MobileModal/custom-modal";

interface FileDeleteProps {
  fileId: number;
  onDelete?: (fileId: number) => void;
}

export function FileDelete({ fileId, onDelete }: FileDeleteProps) {
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] =
    useState<boolean>(false);

  async function handleDelete() {
    const result = await fileService.deleteFile(fileId);
    if (onDelete && result) {
      onDelete(fileId);
    }
  }

  const confirmationFormProps: CustomModalProps = {
    header: "Potwierdź",
    body: "Czy chcesz usunąć ten plik?",
    height: "160px",
    width: "50%",
    isOpen: isConfirmationModalOpen,
    confirmation: true,
    onClose: () => setIsConfirmationModalOpen(false),
    centered: true,
    justified: true,
    onConfirm: handleDelete,
  };

  return (
    <>
      {!!confirmationFormProps && <CustomModal {...confirmationFormProps} />}
      <div
        className="cursor-pointer text-red-500 hover:text-red-700"
        onClick={() => setIsConfirmationModalOpen(true)}
        title="Usuń plik"
      >
        Usuń
      </div>
    </>
  );
}
